import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';
import { Profile } from 'src/model/profile.model';

@Component({
    selector: 'app-transfer-simpan',
    templateUrl: './transfer-simpan.component.html',
    styleUrls: ['./transfer-simpan.component.scss'],
    standalone: false
})
export class TransferSimpanComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);

  companyBankAccountList: Account[] = [];
  cashAccountList: Account[] = [];
  selectedAccountId: number;

  amount: number;
  simpanDate: Date = new Date();
  remark: string;
  toProfileId: number;

  @Input() selectedProfileID: number;
  @Input() profileList: Profile[];

  @Output() passEntry = new EventEmitter<any>();

  disabledSubmit = false;

  ngOnInit(): void {
    const companyId = Number(sessionStorage.getItem("companyId"));
    this.getAllAccountsOfCompany(companyId);
  }

  private getAllAccountsOfCompany(companyId: number) {
    const loggedInUsername = sessionStorage.getItem("username");
    const xhttp = this.restapi.getRequest(this.constructApi.getAccountsOfCompany(companyId));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const account = new Account(json.id, json.number, json.name, json.holderName, json.balance, json.companyId, json.username);

          if (account.Username == undefined)
            this.companyBankAccountList.push(account);
          else if (account.Username == loggedInUsername)
            this.cashAccountList.push(account);
        });
      }
    };
  }

  fieldIsNull() {
    const amountNull = this.amount == undefined || this.amount == 0;
    const remarkNull = this.remark == undefined;
    const accountNull = this.selectedAccountId == undefined;
    const profileNull = this.toProfileId == undefined;

    return amountNull || remarkNull || accountNull || profileNull
  }

  submit() {
    if (this.fieldIsNull() == true) {
      this.sharedService.openAlert("Please fill in all fields correctly", ALERT_TYPE.DANGER);
    } else {
      this.transferSimpan();
    }
  }

  transferSimpan() {
    this.disabledSubmit = true;
    const isoDate = (new Date(Number(this.simpanDate))).toISOString();

    const data = {
      "toProfile": Number(this.toProfileId),
      "amount": this.amount,
      "remark": this.remark,
      "date": isoDate,
      "accountId": Number(this.selectedAccountId)
    };

    const xhr = this.restapi.postRequest(this.constructApi.getTransferReserve(this.selectedProfileID), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        if (xhr.status == 200) {
          this.sharedService.openAlert("Successfully transferred simpan!", ALERT_TYPE.SUCCESS);
          window.location.reload();
        }
        else
          this.sharedService.openErrorMessage(xhr);
      }
    }
  }

  reset() {
    this.activeModal.close();
  }
}
